/*
*@Author: dcl
*@Description: 公示栏
*@Date: 2022-11-14 11:27:35
*/
<template>
<div class="ib-box">
    <div class="box-con" v-for="(item, index) in earningsList" :key="index + 'earningsList'">
        <div class="con-right">
            <div class="right-txt">
                {{ item.year }}
            </div>
            <div class="right-line"></div>
        </div>
        <div class="con-middle"></div>
        <div class="con-left">
            <div class="con-time">{{ item.title }}</div>
            <div class="con-txt">
                {{ item.context }}
            </div>
        </div>
    </div>
</div>
</template>

<script>
export default {
    data() {
        return {
            earningsList: [{
                year: '2022年度',
                title: '2022年基本财务信息',
                context: '截至2022年12月31日，东风南方保险代理有限公司河北分公司总资产为962,825.89元，净资产总额为478,485.74元；2022年的主营业务收入为10,157,569.29元，净利润为478,485.74元。'
            }, {
                year: '2021年度',
                title: '2021年基本财务信息',
                context: '截至2021年12月31日，东风南方保险代理有限公司河北分公司总资产为680,774.27元，净资产总额为422,506.77元；2021年的主营业务收入为13,922,924.34元，净利润为422,506.77元。'
            }, {
                year: '2020年度',
                title: '2020年基本财务信息',
                context: '截至2020年12月31日，东风南方保险代理有限公司河北分公司总资产为1,222,967.06元，净资产总额为782,301.11元；2020年的主营业务收入为20,761,553.16元，净利润为782,301.11元。'
            }, {
                year: '2019年度',
                title: '2019年基本财务信息',
                context: '截至2019年12月31日，东风南方保险代理有限公司河北分公司总资产为1,367,142.92元，净资产总额为741,527.81元；2019年的主营业务收入为23,342,500.2元，净利润为741,527.81元。'
            }, {
                year: '2018年度',
                title: '2018年基本财务信息',
                context: '截至2018年12月31日，东风南方保险代理有限公司河北分公司总资产为1,747,440.58元，净资产总额为892,423.6元；2018年的主营业务收入为42,697,324.34元，净利润为698,257.86元。'
            }]
        };
    }
};
</script>

<style lang="less" scoped>
::-webkit-scrollbar-track-piece {
    //滚动条凹槽的颜色，还可以设置边框属性
    background-color: #f8f8f8;
}

::-webkit-scrollbar {
    //滚动条的宽度
    width: 9px;
    height: 9px;
}

::-webkit-scrollbar-thumb {
    //滚动条的设置
    background-color: #dddddd;
    background-clip: padding-box;
    min-height: 28px;
}

::-webkit-scrollbar-thumb:hover {
    background-color: #bbb;
}

.ib-box {
    height: 370px;
    overflow-y: auto;
    font-size: 0.53rem;

    .box-con {
        display: flex;
        flex-direction: row;

        .con-right {
            display: flex;
            justify-content: center;
            align-items: center;
            flex-direction: column;
            width: 3.47rem;

            .right-txt {
                padding: .13rem .53rem .1rem;
                color: 0.6rem;
                text-align: center;
                color: #FFFFFF;
                background-color: #FF9600;
            }

            .right-line {
                margin: .2rem 0;
                height: calc(100% - .2rem);
                width: 0;
                border: 0.03rem dashed #FF9600;
            }
        }

        .con-middle {
            height: 0.03rem;
            width: 0.9rem;
            background-color: #FF9600;
            margin: .47rem .3rem 0 .33rem;
        }

        .con-left {
            padding: .5rem .63rem 0;
            color: 0.53rem;
            background-color: #FAFAFA;
            width: 35.41rem;
            margin-bottom: 1.47rem;

            .con-time {
                font-weight: bold;
                color: #FF0000;
            }

            .con-txt {
                padding: .27rem 0 1.03rem;
            }
        }
    }

    .box-con:first-child {
        margin-top: 1.4rem;
    }
}
</style>



// WEBPACK FOOTER //
// src/view/Informationhb/base.vue